import { adminServerInstance } from "../axios/instances";
import { PAYROLL_ADJUSTMENT as type } from "./payrollAdjustmentTypes";
import axios from "axios";
import { getUserPreference } from "../utilities/common";

/**
 * @param {string} payment_cycle
 * @param {int} warehouse
 * @param {int} driver_id
 */
export function approveDailyLog(params) {
    return function (dispatch) {
        dispatch({ type: type.APPROVE_DAILYLOG });
        return adminServerInstance
            .post('/payroll/dailylog/approve', params) // pass params directly
            .then(({ data }) => {
                dispatch({
                    type: type.APPROVE_DAILYLOG_SUCCESS,
                    payload: data.data,
                });
                return Promise.resolve(data.data);
            })
            .catch((error) => {
                dispatch({
                    type: type.APPROVE_DAILYLOG_FAIL,
                    payload: error,
                });
                return Promise.reject(error);
            });
    };
}

/**
 * @param {int} logs
 * @param {string} selectedDate
 * @param {int} warehouse
 */
export function createDailyLog(params) {
    return function (dispatch) {
        dispatch({ type: type.CREATE_DAILYLOG });
        return adminServerInstance
            .post('/payroll/dailylog/create', params) // Use axios.get and pass params as query parameters
            .then(({ data }) => {
                dispatch({
                    type: type.CREATE_DAILYLOG_SUCCESS,
                    payload: data.data,
                });
                return Promise.resolve(data.data);
            })
            .catch((error) => {
                dispatch({
                    type: type.CREATE_DAILYLOG_FAIL,
                    payload: error,
                });
                return Promise.reject(error);
            });
    };
}

/**
 * @param {int} log_id 
 */
export function getDailyLogDetail(params) {
    return function (dispatch) {
        dispatch({ type: type.PAYROLL_DAILYLOG_DETAIL });
        return adminServerInstance
            .get('/payroll/dailylog/detail', { params }) // Use axios.get and pass params as query parameters
            .then(({ data }) => {
                dispatch({
                    type: type.PAYROLL_DAILYLOG_DETAIL_SUCCESS,
                    payload: data.data,
                });
                return Promise.resolve(data.data);
            })
            .catch((error) => {
                dispatch({
                    type: type.PAYROLL_DAILYLOG_DETAIL_FAIL,
                    payload: error,
                });
                return Promise.reject(error);
            });
    };
}

/**
 * @param {int} warehouse
 * @param {string} payment_cycle
 * @param {int} status 1 New Entry or 2 To be Reviewed
 * @param {int} driverId
 * @returns 
 */
export function searchHoursReivewDetails(params) {
    return function (dispatch) {
        dispatch({ type: type.HOURS_REVIEW_SEARCH });
        return adminServerInstance
            .get('/payroll/dailylog/summary', { params }) // Use axios.get and pass params as query parameters
            .then(({ data }) => {
                dispatch({
                    type: type.HOURS_REVIEW_SEARCH_SUCCESS,
                    payload: data.data,
                });
                return Promise.resolve(data.data);
            })
            .catch((error) => {
                dispatch({
                    type: type.HOURS_REVIEW_SEARCH_FAIL,
                    payload: error,
                });
                return Promise.reject(error);
            });
    };
}

/**
 * @param {String} batch_info 
 * @param {int} driver_id
 * @param {int} warehouse
 * @param {String} date
 */
export function searchDailyLog(params) {
    return function (dispatch) {
        dispatch({ type: type.PAYROLL_DAILYLOG_SEARCH });
        return adminServerInstance
            .get('/payroll/dailylog/search', { params }) // Use axios.get and pass params as query parameters
            .then(({ data }) => {
                dispatch({
                    type: type.PAYROLL_DAILYLOG_SEARCH_SUCCESS,
                    payload: data.data,
                });
                return Promise.resolve(data.data);
            })
            .catch((error) => {
                dispatch({
                    type: type.PAYROLL_DAILYLOG_SEARCH_FAIL,
                    payload: error,
                });
                return Promise.reject(error);
            });
    };
}

/**
 * @param {int} log_id
 * @param {int} hours 
 * @returns 
 */
export function updateDailyLog(params) {
    return function (dispatch) {
        dispatch({ type: type.UPDATE_PAYROLL_DAILYLOG });
        return adminServerInstance
            .put('/payroll/dailylog/update', params) // Use axios.get and pass params as query parameters
            .then(({ data }) => {
                dispatch({
                    type: type.UPDATE_PAYROLL_DAILYLOG_SUCCESS,
                    payload: data.data,
                });
                return Promise.resolve(data.data);
            })
            .catch((error) => {
                dispatch({
                    type: type.UPDATE_PAYROLL_DAILYLOG_FAIL,
                    payload: error,
                });
                return Promise.reject(error);
            });
    };
}


export function handleRowValues(params) {
    return function (dispatch) {
        dispatch({ type: type.HANDLE_ROW_VALUES })
        return (
            dispatch({
                type: type.HANDLE_ROW_VALUES,
                payload: params
            })
        )
    }
}

export function getPaymentCycle() {
    return function (dispatch) {
        dispatch({ type: type.PAYROLL_ADJUSTMENT_PAYMENT_CYCLE_LOAD })
        return adminServerInstance.get(`/payroll/getpayrollcycles`)
            .then(({ data }) => {
                dispatch({
                    type: type.PAYROLL_ADJUSTMENT_PAYMENT_CYCLE_LOAD_SUCCESS,
                    payload: data.data,
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.PAYROLL_ADJUSTMENT_PAYMENT_CYCLE_LOAD_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getChargeReason() {
    return function (dispatch) {
        dispatch({ type: type.PAYROLL_ADJUSTMENT_CHARGE_REASON_LOAD })
        return adminServerInstance.get(`/payroll/getchargereasons`)
            .then(({ data }) => {
                dispatch({
                    type: type.PAYROLL_ADJUSTMENT_CHARGE_REASON_LOAD_SUCCESS,
                    payload: data.data,
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.PAYROLL_ADJUSTMENT_CHARGE_REASON_LOAD_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getEstimateAmount(trackingId) {
    return function (dispatch) {
        dispatch({ type: type.PAYROLL_ADJUSTMENT_CHARGE_REASON_LOAD })
        return adminServerInstance.get(`/payroll/gettotalvalue?tracking_nos=${trackingId}`)
            .then(({ data }) => {
                dispatch({
                    type: type.PAYROLL_ADJUSTMENT_CHARGE_REASON_LOAD_SUCCESS,
                    payload: data.data,
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.PAYROLL_ADJUSTMENT_CHARGE_REASON_LOAD_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function viewPayroll(id) {
    return function (dispatch) {
        dispatch({ type: type.PAYROLL_ADJUSTMENT_VIEW_PAYROLL_LOAD })
        return adminServerInstance.get(`/payroll/view?adjustment_id=${id}`)
            .then(({ data }) => {
                dispatch({
                    type: type.PAYROLL_ADJUSTMENT_VIEW_PAYROLL_LOAD_SUCCESS,
                    payload: data.data,
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.PAYROLL_ADJUSTMENT_VIEW_PAYROLL_LOAD_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

/**
 *
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.payment_cycle - payment cycle
 * @param {number} params.status - 1, 2 or 3  -1 means all
 * @param {number} params.adjustment- 1 or 2  -1 means all
 * @param {string} params.deduction_subsidy- 1 or 2  -1 means all
 * @param {number} params.amount_from amount from
 * @param {number} params.amount_to amount to
 * @param {number} params.driver_id Driver ID
 */
export function getAllPayrolls(params) {
    return function (dispatch) {
        dispatch({ type: type.PAYROLL_ADJUSTMENT_VIEW_ALL_PAYROLLS_LOAD })
        return adminServerInstance.post(`/payroll/search`, params)
            .then(({ data }) => {
                dispatch({
                    type: type.PAYROLL_ADJUSTMENT_VIEW_ALL_PAYROLLS_LOAD_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.PAYROLL_ADJUSTMENT_VIEW_ALL_PAYROLLS_LOAD_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

/**
 *
 * @param {Object} formData - combined object to send for server processing
 * @param {string} formData.driver_id - driver ID
 * @param {number} formData.status -  1, 2 or 3
 * @param {number} formData.deduction_subsidy - 1 or 2
 * @param {number} formData.charge_reason- reason ID
 * @param {number} formData.amount- amount
 * @param {String} formData.tracking_nos- tracking Numbers
 * @param {number} formData.operator- Current User ID
 * @param {String} formData.description- description
 * @param {binary} formData.file_one- FILE ONE
 * @param {binary} formData.file_two- FILE TWO
 * @param {binary} formData.file_three- FILE THREE
 * @param {binary} formData.file_four- FILE FOUR
 * @param {number} formData.warehouse- Current Login Warehouse
 */
export function createPayroll(formData) {
    return function (dispatch) {
        dispatch({ type: type.PAYROLL_ADJUSTMENT_CREATE_PAYROLL_LOAD })
        return adminServerInstance.post(`/payroll/create`, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        ).then(({ data }) => {
            dispatch({
                type: type.PAYROLL_ADJUSTMENT_CREATE_PAYROLL_LOAD_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: type.PAYROLL_ADJUSTMENT_CREATE_PAYROLL_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 *
 * @param {Object} formData - combined object to send for server processing
 * @param {string} formData.driver_id - driver ID
 * @param {number} formData.status -  1, 2 or 3
 * @param {number} formData.deduction_subsidy - 1 or 2
 * @param {number} formData.charge_reason- reason ID
 * @param {number} formData.amount- amount
 * @param {String} formData.tracking_nos- tracking Numbers
 * @param {number} formData.operator- Current User ID
 * @param {String} formData.description- description
 * @param {binary} formData.file_one- FILE ONE
 * @param {binary} formData.file_two- FILE TWO
 * @param {binary} formData.file_three- FILE THREE
 * @param {binary} formData.file_four- FILE FOUR
 * @param {number} formData.adjustment_id- Adjustment ID
 * @param {String} formData.updated_files- Updated files
 */
export function updatePayroll(formData) {
    return function (dispatch) {
        dispatch({ type: type.PAYROLL_ADJUSTMENT_UPDATE_PAYROLL_LOAD })
        return adminServerInstance.post(`/payroll/update`, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        ).then(({ data }) => {
            dispatch({
                type: type.PAYROLL_ADJUSTMENT_UPDATE_PAYROLL_LOAD_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: type.PAYROLL_ADJUSTMENT_UPDATE_PAYROLL_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 *
 * @param {number} params.operator- Current User ID
 * @param {number} params.id- Adjustment ID
 */
export function deletePayroll(params) {
    return function (dispatch) {
        dispatch({ type: type.PAYROLL_ADJUSTMENT_DELETE_PAYROLL_LOAD })
        return adminServerInstance.post(`/payroll/delete`, params
        ).then(({ data }) => {
            dispatch({
                type: type.PAYROLL_ADJUSTMENT_DELETE_PAYROLL_LOAD_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.PAYROLL_ADJUSTMENT_DELETE_PAYROLL_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 *
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.payment_cycle - payment cycle
 * @param {number} params.selected_status -  1|2
 * @param {number} params.amount- amount
 * @param {String} params.adjustments- SELECTED Entry ID
 * @param {number} params.operator- Current User ID
 */
export function updateBatchPayroll(params) {
    return function (dispatch) {
        dispatch({ type: type.PAYROLL_ADJUSTMENT_UPDATE_BATCH_LOAD })
        return adminServerInstance.post(`/payroll/batch/update`, params
        ).then(({ data }) => {
            dispatch({
                type: type.PAYROLL_ADJUSTMENT_UPDATE_BATCH_LOAD_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.PAYROLL_ADJUSTMENT_UPDATE_BATCH_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 *
 * @param {Object} params - combined object to send for server processing
 * @param {number} params.adjustment_id -  Adjustment ID
 * @param {String} params.file_name- File Name
 */
export function downloadSavedFiledBlob(params) {
    return axios.post(`${process.env.REACT_APP_MAP_SERVER_URL}/payroll/downloadfile`, params, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/octet-stream',
            'Authorization': `Bearer ${getUserPreference().authToken}`
        },
        timeout: 0
    }).then((response) => {
        if (response.headers['content-type'] === "application/json") {
            return Promise.reject(response);
        } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: response.data.type }));
            const link = document.createElement('a');
            link.href = url;
            link.download = params.file_name;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    }).catch((error) => {
        return Promise.reject(error);
    })
}


/**
 *
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.payment_cycle - payment Cycle
 */
export function downloadPayrollExcelBlob(params) {
    return axios.post(`${process.env.REACT_APP_MAP_SERVER_URL}/payroll/dowloadsummary`, params, {
        responseType: 'blob',
        headers: {
            'Authorization': `Bearer ${getUserPreference().authToken}`
        },
        timeout: 0
    })
        .then((response) => {
            if (response.headers['content-type'] === "application/json") {
                return Promise.reject(response);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'payroll.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        })
        .catch((error) => {
            return Promise.reject(error);
        })
}